<div class="smr-stylist-calendar-container styled-scrollbars">
  <div class="smr-stylist-calendar-header">
    <div
      *ngFor="let view of views; let viewIndex = index"
      [ngStyle]="{
        flex: '1 0 175px',
        'margin-left': viewIndex == 0 ? '61px' : '0',
        'margin-right': viewIndex % 2 != 0 ? '77px' : '0'
      }"
      tappable
      (click)="onStylistTap(view.stylist)"
    >
      <ion-item lines="none">
        <ion-label class="sm-cal-avatar-label">
          <ion-avatar
            [hidden]="
              view.stylist.getPhotoUrl() == '' ||
              view.stylist.getPhotoUrl() == undefined ||
              view.stylist.getPhotoUrl() == null
            "
          >
            <img
              src="{{ env_config.STAFF_THUMBNAIL_PHOTO_ROOT }}/{{
                view.stylist.getPhotoUrl()
              }}"
            />
          </ion-avatar>
          <smr-circle-text-avatar
            [hidden]="
              view.stylist.getPhotoUrl() != '' &&
              view.stylist.getPhotoUrl() != undefined &&
              view.stylist.getPhotoUrl() != null
            "
            [firstName]="view.stylist.getFirstName()"
            [lastName]="view.stylist.getLastName()"
          >
          </smr-circle-text-avatar>
        </ion-label>

        <ion-label>
          {{ view.stylist.firstName }}
        </ion-label>
      </ion-item>
    </div>
  </div>

  <div class="smr-stylist-calendar-content">
    <smr-day-view-calendar
      *ngFor="let view of views; trackBy: trackByFn; let viewIndex = index"
      [config]="view"
      (onEventSelected)="eventSelectedHandler($event)"
      (onTimeSelected)="onTimeSelectedHandler($event)"
      (onEventDragEnd)="onEventDragEndHandler($event)"
      class="sm-scroll-item ion-no-padding"
      [ngStyle]="{
        flex:
          viewIndex == 0
            ? '1 0 236px'
            : viewIndex % 2 == 0
            ? '1 0 252px'
            : '1 0 175px'
      }"
    >
    </smr-day-view-calendar>
  </div>
</div>
